/**
 * Created by Christof Sander on 03.03.2017.
 */

module.exports = {
	config: {

	},


};